import { NewContract } from '../models/Entities/Contracts/NewContract';
import { Contract } from '../models/Entities/Contracts/Contract';
import { IResult } from '../models/HttpResult';

//Functions
import * as Functions from '../functions/common';

// Error Tracer
import * as Sentry from '@sentry/react';

// models
import { ContractProtocolAssociation } from '../models/Entities/Contracts/ContractProtocolAssociation';
import { ContractPractitionerAssociation } from '../models/Entities/Contracts/ContractPractitionerAssociation';
import { ContractToClone } from '../models/Entities/Contracts/ContractToClone';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'contracts/';
const BaseURLProtocols = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/contracts/contracts';
const BaseURLPractitioners = process.env.REACT_APP_BILLER_API_GATEWAY + 'practitioners/contracts/contracts';

// Get All Contracts
export const GetContracts = async (token: string): Promise<Contract[]> => {

    let RequestURL: string = BaseURL;

    try {
        const Response: Contract[] = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
        .then((response) => {
            if (!response.ok) {
                Sentry.captureException(response);
                throw response;
            } else {
                return response.json() as Promise<IResult<Contract[]>>;
            }
        })
        .then((data: IResult<Contract[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Get contract By Id
export const GetContractById = async (id: number, token: string): Promise<Contract> => {

    let RequestURL: string = BaseURL + id;

    try {
        const Response: Contract = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<Contract>>;
                }
            })
            .then((data: IResult<Contract>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Create Contract
export const CreateContract = async (contract: NewContract, token: string): Promise<Contract> => {

    let RequestURL: string = BaseURL;

    try {
        const Response: Contract = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            body: JSON.stringify(contract)
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<Contract>>;
                }
            })
            .then((data: IResult<Contract>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Update Contract
export const UpdateContract = async (contract: Contract, token: string): Promise<Contract> => {

    let RequestURL: string = BaseURL;

    try {
        const Response: Contract = await fetch(RequestURL, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            body: JSON.stringify(contract)
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<Contract>>;
                }
            })
            .then((data: IResult<Contract>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Associate to protocol
export const AssociateToProtocol = async (contractId: number, protocolId: number, isPrimary: boolean, token: string): Promise<ContractProtocolAssociation> => {

    let RequestURL: string = BaseURLProtocols;

    try {
        const Response: ContractProtocolAssociation = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            body: JSON.stringify({
                "contractId": contractId,
                "protocolId": protocolId,
                "isPrimary": isPrimary
            })
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<ContractProtocolAssociation>>;
                }
            })
            .then((data: IResult<ContractProtocolAssociation>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// disassociate from protocol
export const DisassociateFromProtocol = async (contractProtocolId: number, token: string): Promise<number> => {

    let RequestURL: string = BaseURLProtocols + '/' + contractProtocolId;

    try {
        const Response: number = await fetch(RequestURL, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<number>>;
                }
            })
            .then((data: IResult<number>) => {
                return contractProtocolId;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Associate to protocol
export const AssociateToPractitioner = async (contractId: number, PractitionerId: string, token: string): Promise<ContractPractitionerAssociation> => {
    
    let RequestURL: string = BaseURLPractitioners;

    try {
        const Response: ContractPractitionerAssociation = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            body: JSON.stringify({
                "contractId": contractId,
                "practitionerId": PractitionerId
            })
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<ContractPractitionerAssociation>>;
                }
            })
            .then((data: IResult<ContractPractitionerAssociation>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// disassociate from practitioner
export const DisassociateFromPractitioner = async (contractPractitionerId: number, token: string): Promise<number> => {
    
    let RequestURL: string = BaseURLPractitioners + '/' + contractPractitionerId;

    try {
        const Response: number = await fetch(RequestURL, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<number>>;
                }
            })
            .then((data: IResult<number>) => {
                return contractPractitionerId;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// check protocol contract association
export const CheckProtocolContractAssociation = async (contractId: number, token: string): Promise<number | null> => {

    // Swagger: GET /protocols/contracts/contracts/checkassociation?ContractId={id}
    let RequestURL: string = BaseURLProtocols + '/checkassociation?ContractId=' + contractId;

    try {
        const Response: number | null = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<number | null>>;
                }
            })
            .then((data: IResult<number | null>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// check practitioner contract association
export const CheckPractitionerContractAssociation = async (contractId: number, token: string): Promise<string | null> => {

    let RequestURL: string = BaseURLPractitioners + '/checkassociation?ContractId=' + contractId;

    try {
        const Response: string | null = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<string | null>>;
                }
            })
            .then((data: IResult<string | null>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            ).catch((error: any) => {
                throw Functions.HttpErrorHandler(null, error);
            });
        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// Change fee division
export const ChangeFeeDivision = async (contractId: number, feeDivision: number, token: string): Promise<number> => {

    // Swagger: PATCH /contracts/{ContractId}/feedivision/{FeeDivisionValue}
    let RequestURL: string = BaseURL + contractId.toString() + '/feedivision/' + feeDivision.toString();

    try {
        const Response: number = await fetch(RequestURL, {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<number>>;
                }
            })
            .then((data: IResult<number>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// clone contract 
export const CloneContract = async (contract : ContractToClone, token: string): Promise<Contract> => {

    let RequestURL: string = BaseURL + 'clone';

    try {
        const Response: Contract = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            body: JSON.stringify(contract)
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<Contract>>;
                }
            })
            .then((data: IResult<Contract>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// delete contract
export const DeleteContract = async (contractId: number, token: string): Promise<number> => {

    let RequestURL: string = BaseURL + contractId;

    try {
        const Response: number = await fetch(RequestURL, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<number>>;
                }
            })
            .then((data: IResult<number>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

// get contract by protocol id
export const GetContractByProtocolId = async (protocolId: number, token: string): Promise<Contract> => {

    // Swagger: GET /contracts/protocol/{ProtocolId}
    let RequestURL: string = BaseURL + 'protocol/' + protocolId;

    try {
        const Response: Contract = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<Contract>>;
                }
            })
            .then((data: IResult<Contract>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};

export const GetContractByPractitionerId = async (practitionerId: string, token: string): Promise<Contract> => {

    let RequestURL: string = BaseURLPractitioners + '/' + practitionerId;

    try {
        const Response: Contract = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<Contract>>;
                }
            })
            .then((data: IResult<Contract>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};


// Mark the contract as verified / unverified
export const SetContractVerified = async (contractId: number, verified: boolean, token: string): Promise<number> => {

    // Swagger: PATCH /contracts/{ContractId}/verified/{Verified}
    let RequestURL: string = BaseURL + contractId.toString() + '/verified/' + verified.toString();

    try {
        const Response: number = await fetch(RequestURL, {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (!response.ok) {
                    Sentry.captureException(response);
                    throw response;
                } else {
                    return response.json() as Promise<IResult<number>>;
                }
            })
            .then((data: IResult<number>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return Response;
    } catch (error: any) {
        Sentry.captureException(error);
        throw error;
    }
};
